import { getAuthItem } from '@/lib/authStorage';
import { getActiveWorkspaceId } from '@/lib/api/workspace-context';

export function getHeaders(): Record<string, string> {
  const token = getAuthItem('xavior_auth_token');
  const userId = getAuthItem('userId');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    'X-Workspace-Id': getActiveWorkspaceId(),
    ...(userId ? { 'X-Actor-Id': userId } : {}),
  };
}
